export const saveBlob = (pdfData: string) => {
  const newBlob = b64toBlob(pdfData, "application/pdf");

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  link.href = data;
  link.download = "report.pdf";
  link.click();
  setTimeout(
    () =>
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data),
    100
  );
};

export const b64toBlob = (
  b64Data: string,
  contentType: string = "",
  sliceSize: number = 512
) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const quickFetch = (
  serviceURL: string,
  request: any,
  init: RequestInit = {}
) => {
  const headers = new Headers([
    ["Accept", "application/json, text/plain, */*"],
    ["Content-Type", "application/json"]
  ]);

  return fetch(serviceURL, {
    method: "POST",
    headers,
    body: request && JSON.stringify(request),
    ...init
  });
};
